import { c as _c } from "react/compiler-runtime";
import { createContext, useState, ReactNode } from "react";
export const CarouselContext = createContext<{
  activeIndex: number;
  setActiveIndex: (index: number) => void;
  goToPrevious: () => void;
  goToNext: () => void;
  hasPrevious: boolean;
  hasNext: boolean;
}>({
  activeIndex: -1,
  setActiveIndex: () => {},
  goToPrevious: () => {},
  goToNext: () => {},
  hasPrevious: false,
  hasNext: false
});
export function CarouselProvider(t0) {
  const $ = _c(18);
  const {
    children,
    slideCount,
    shouldWrap: t1
  } = t0;
  const shouldWrap = t1 === undefined ? false : t1;
  const [activeIndex, setInternalActiveIndex] = useState(0);
  const hasPrevious = shouldWrap || activeIndex > 0;
  const hasNext = shouldWrap || activeIndex < slideCount - 1;
  let t2;
  if ($[0] !== slideCount) {
    t2 = index => {
      if (index < 0 || index >= slideCount) {
        return;
      }
      setInternalActiveIndex(index);
    };
    $[0] = slideCount;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const setActiveIndex = t2;
  let t3;
  if ($[2] !== shouldWrap || $[3] !== slideCount) {
    t3 = () => {
      setInternalActiveIndex(currentIndex => {
        if (currentIndex <= 0) {
          return shouldWrap ? slideCount - 1 : 0;
        }
        return currentIndex - 1;
      });
    };
    $[2] = shouldWrap;
    $[3] = slideCount;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const goToPrevious = t3;
  let t4;
  if ($[5] !== shouldWrap || $[6] !== slideCount) {
    t4 = () => {
      setInternalActiveIndex(currentIndex_0 => {
        if (currentIndex_0 >= slideCount - 1) {
          return shouldWrap ? 0 : slideCount - 1;
        }
        return currentIndex_0 + 1;
      });
    };
    $[5] = shouldWrap;
    $[6] = slideCount;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const goToNext = t4;
  let t5;
  if ($[8] !== activeIndex || $[9] !== goToNext || $[10] !== goToPrevious || $[11] !== hasNext || $[12] !== hasPrevious || $[13] !== setActiveIndex) {
    t5 = {
      activeIndex,
      setActiveIndex,
      goToPrevious,
      goToNext,
      hasPrevious,
      hasNext
    };
    $[8] = activeIndex;
    $[9] = goToNext;
    $[10] = goToPrevious;
    $[11] = hasNext;
    $[12] = hasPrevious;
    $[13] = setActiveIndex;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== children || $[16] !== t5) {
    t6 = <CarouselContext.Provider value={t5}>{children}</CarouselContext.Provider>;
    $[15] = children;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}